import React, { MouseEvent, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { getTrunkedNetworkDisplayNames } from '../ViewAllNetworksModal/utils/utils';
import { getNetworkOrVlansCellDisplay } from './utils/utils';
import { NetworkOrVlansCellRendererProps } from './container';
import styles from './NetworkOrVlansCellRenderer.module.css';

export const NetworkOrVlansCellRenderer = ({
  nic,
  networks,
  setViewAllNetworksModal,
}: NetworkOrVlansCellRendererProps): ReactElement => {
  const { t } = useTranslation();
  const allSessionVlansLabel = t('networks.trunk.allSessionVlans');

  const display = getNetworkOrVlansCellDisplay(nic, allSessionVlansLabel);

  if (display.kind === 'viewAll') {
    return (
      <button
        className={styles.viewButton}
        onClick={(e: MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation();

          setViewAllNetworksModal(
            getTrunkedNetworkDisplayNames(
              networks,
              allSessionVlansLabel,
              nic.trunk,
            ),
          );
        }}
        type="button"
      >
        {t('networks.trunk.viewAll', {
          count: display.count,
        })}
      </button>
    );
  }

  return <span>{display.text}</span>;
};
